import { Page, PageBody, PageHeader } from "@/components/app-layout";
import { BasicWriter } from "@/components/Writer/BasicWriter";
import { useScriptData } from "@/data/use-script-data";
import { useGroupUuid } from "@/hooks/use-group-uuid";
import { useParams } from "@tanstack/react-router";
import { useEffect, useRef } from "react";

export default function ScriptEditPage() {
  const groupUuid = useGroupUuid();
  const { scriptUuid } = useParams({ strict: false }) as {
    scriptUuid?: string;
  };
  const { script } = useScriptData(groupUuid, scriptUuid ?? null);

  if (!script) {
    return null;
  }

  return (
    <Page document>
      <PageHeader document>
        <PageHeader.Title>Script</PageHeader.Title>
      </PageHeader>
      <PageBody document>
        <ScriptBody scriptUuid={script.uuid} />
      </PageBody>
    </Page>
  );
}

function ScriptBody({ scriptUuid }: { scriptUuid: string }) {
  const groupUuid = useGroupUuid();
  const contentRef = useRef<string>("");
  const hasInitialized = useRef(false);
  const { updateScript, script } = useScriptData(groupUuid, scriptUuid);

  useEffect(() => {
    if (script && !hasInitialized.current) {
      contentRef.current = script.content;
      hasInitialized.current = true;
    }
  }, [script]);

  // Handle content updates from BasicWriter (debounced internally)
  const handleContentUpdate = (html: string) => {
    if (script) {
      updateScript({
        content: html,
      });
    }
  };

  if (!script) {
    return null;
  }

  return (
    <div className="flex w-full flex-grow flex-col gap-4 overflow-auto">
      <div className="w-full">
        <BasicWriter
          key={`content-${script.uuid}`}
          content={script.content}
          onUpdate={handleContentUpdate}
          onChange={(html) => {
            contentRef.current = html;
          }}
          placeholder="Enter the interview script content, questions, guidelines, and evaluation criteria..."
          hasToolbar={false}
        />
      </div>
    </div>
  );
}
